import React, {useEffect, useState} from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import AuthLayout from "../../components/Layouts/AuthLayout";
import Divider from "../../components/Divider";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import GoogleLogo from "../../assets/icons/google-logo.png";
import {Link} from "react-router-dom";
import { RouteNames } from "../../constants";
import { loginUser } from "../../redux/auth/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../../components/LoadingSpinner";
import ErrorViewer from "../../components/ErrorViewer";
import {toast} from "react-toastify";
import {
    generateRecaptureLink,
    getKYCStatus,
    validateEmail, validatePhoneNumber,
    verifyEmail
} from "../../redux/selfService/selfServiceSlice";
import VerifyEmailOrPhone from "../../components/Auth/VerifyEmailOrPhone";
import SuccessModal from "../../components/SuccessModal";
import RecaptureModal from "../../components/Auth/RecaptureModal";
import ChangePasswordModal from "../../components/Auth/ChangePasswordModal";
import Modal from "../../components/Base/Modal";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const { isLoading } = useAppSelector((state) => state?.auth);
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const [successModalText, setSuccessModalText] = useState("")
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showChangePasswordModal,setShowChangePasswordModal] =useState(false)
  const [verifyItem, setVerifyItem] = useState<"email"|"phone">("email")
  const [showRecaptureModal, setShowRecaptureModal] = useState(false)
  const [showOtpModal, setShowOtpModal] = useState(false)
  const [otpRequestId, setOtpRequestId] = useState("")
  const [otpMaskedEmail, setOtpMaskedEmail] = useState("")
  const [pendingLogin, setPendingLogin] = useState<any>(null)
  const [otpValue, setOtpValue] = useState("")
  const [otpError, setOtpError] = useState("")
  const [resendingOtp, setResendingOtp] = useState(false)

  const [showExpiryMessage, setShowExpiryMessage] = useState(true)
  useEffect(()=>{
    const queryParams = new URLSearchParams(window.location.search);
    if(showExpiryMessage &&queryParams.has('session-expired')){
      toast.error(`Session Expired \nPlease login again`);
    }
  }, [])

  const validationSchema = Yup.object().shape({
    userName: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      userName: "",
      password: "",
    },
  });

  const responseCode = (payload: any) => payload?.statusCode || payload?.StatusCode;
  const responseMessage = (payload: any) =>
    payload?.message || payload?.Message || payload?.statusMessage || payload?.StatusMessage;
  const responseObject = (payload: any) => payload?.responseObject || payload?.ResponseObject || payload;

  const completePostLogin = async (dispatchLogin: any) => {
    setTimeout(async ()=>{
      localStorage.setItem('enforceChangePassword','false');
      const payload = dispatchLogin?.payload;
      const obj = responseObject(payload);

      if(responseCode(payload)==='03'){
         setShowExpiryMessage(false);
          setShowChangePasswordModal(true);
        localStorage.setItem('enforceChangePassword','true');
      }
      else if(!obj?.isEmailVerified && !obj?.isRegistrationIncomplete){
          setShowExpiryMessage(false);
            dispatch(validateEmail());
            setVerifyItem("email")
            setShowVerifyModal(true)
        }
        else if(!obj?.isPhoneNumberVerified && !obj?.isRegistrationIncomplete){
          setShowExpiryMessage(false);
            dispatch(validatePhoneNumber());
            setVerifyItem("phone");
            setShowVerifyModal(true);
        }
        else if (obj?.isRegistrationIncomplete) {
            window.location.replace(RouteNames.REGISTER_COMPLETE);
        }
        else {
            window.location.replace(RouteNames.DASHBOARD);
        }
    }, 500)
  };

  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();
    const loginPayload = {
      ...values,
      deviceID: "web",
      DeviceVersion: "",
      AppVersion: "",
      DeviceOs: "",
      GcmId: ""
    };
    const dispatchLogin = await dispatch(loginUser(loginPayload));
    console.log('dispatchLogin',dispatchLogin);

    if (dispatchLogin?.type === 'auth/login/rejected' && responseCode(dispatchLogin?.payload) === '2FA') {
      const obj = responseObject(dispatchLogin.payload);
      setPendingLogin(loginPayload);
      setOtpRequestId(obj?.requestId || obj?.RequestId || "");
      setOtpMaskedEmail(obj?.maskedEmail || obj?.MaskedEmail || "");
      setOtpValue("");
      setOtpError("");
      setShowOtpModal(true);
      toast.info(responseMessage(dispatchLogin.payload) || "Enter the OTP sent to your email.");
      return;
    }

    if(dispatchLogin?.type === 'auth/login/fulfilled' || (dispatchLogin?.type === 'auth/login/rejected' && responseCode(dispatchLogin?.payload)==='03')){
        console.log('the dispatched login ', dispatchLogin)
        setShowOtpModal(false);
        await completePostLogin(dispatchLogin);
    }
  };

  const onVerifyOtp = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!pendingLogin || !otpRequestId) {
      setOtpError("OTP session expired. Please login again.");
      return;
    }
    if (!otpValue.trim()) {
      setOtpError("Enter the verification code.");
      return;
    }
    setOtpError("");
    const dispatchLogin = await dispatch(loginUser({
      ...pendingLogin,
      otp: otpValue.trim(),
      requestId: otpRequestId,
    }));

    if (dispatchLogin?.type === 'auth/login/rejected' && responseCode(dispatchLogin?.payload) === '2FA') {
      const obj = responseObject(dispatchLogin.payload);
      setOtpRequestId(obj?.requestId || obj?.RequestId || otpRequestId);
      setOtpMaskedEmail(obj?.maskedEmail || obj?.MaskedEmail || otpMaskedEmail);
      setOtpError("Please enter the new code sent to your email.");
      return;
    }

    if (dispatchLogin?.type === 'auth/login/fulfilled' ||
        (dispatchLogin?.type === 'auth/login/rejected' && responseCode(dispatchLogin?.payload) === '03')) {
      setShowOtpModal(false);
      await completePostLogin(dispatchLogin);
      return;
    }

    setOtpError(responseMessage(dispatchLogin?.payload) || "Invalid OTP. Please try again.");
  };

  const onResendOtp = async () => {
    if (!pendingLogin) return;
    setResendingOtp(true);
    setOtpError("");
    try {
      const { otp, requestId, ...withoutOtp } = pendingLogin;
      const dispatchLogin = await dispatch(loginUser(withoutOtp));
      if (dispatchLogin?.type === 'auth/login/rejected' && responseCode(dispatchLogin?.payload) === '2FA') {
        const obj = responseObject(dispatchLogin.payload);
        setOtpRequestId(obj?.requestId || obj?.RequestId || "");
        setOtpMaskedEmail(obj?.maskedEmail || obj?.MaskedEmail || "");
        setOtpValue("");
        toast.success(responseMessage(dispatchLogin.payload) || "A new OTP has been sent.");
      } else {
        setOtpError(responseMessage(dispatchLogin?.payload) || "Unable to resend OTP.");
      }
    } finally {
      setResendingOtp(false);
    }
  };

  const restartLogin = () =>{
      localStorage.removeItem("token")
      setTimeout(()=>{
          window.location.reload()
      }, 2000)
  }

  const onItemVerified = ()=>{
      if(verifyItem === "email") {
          setSuccessModalText("Email verification Successful");
      } else {
          setSuccessModalText("Phone number successfully verified");
      }
      setShowSuccessModal(true);
      setShowVerifyModal(false)
      restartLogin();
    }


    const onChangePasswordVerified = ()=>{
      const storedUser = (() => {
        try { return JSON.parse(localStorage.getItem("user") || "{}"); } catch { return {}; }
      })();
      const incomplete = storedUser.isRegistrationIncomplete || storedUser.IsRegistrationIncomplete;
      setSuccessModalText("Password has been changed successfully!.");
      setShowSuccessModal(true);
      setShowChangePasswordModal(false);
      if (incomplete) {
        setTimeout(() => window.location.replace(RouteNames.REGISTER_COMPLETE), 1500);
        return;
      }
      restartLogin();
    }

  return (
    <AuthLayout>
      <VerifyEmailOrPhone
          item={verifyItem}
          showModal={showVerifyModal}
          onClose={()=>{setShowVerifyModal(false)}}
          onSuccess={onItemVerified}
      />
      <SuccessModal
          showModal={showSuccessModal}
          onClose={()=>setShowSuccessModal(false)}
          note={successModalText}
      />
      <RecaptureModal
          showModal={showRecaptureModal}
          onClose={()=>setShowRecaptureModal(false)}
          onSuccess={restartLogin}
      />

      <ChangePasswordModal item={verifyItem}
          showModal={showChangePasswordModal}
          onClose={()=>{setShowChangePasswordModal(false)}}
          onSuccess={onChangePasswordVerified}
      />

      <Modal
        showModal={showOtpModal}
        onClose={() => {
          setShowOtpModal(false);
          setOtpValue("");
          setOtpError("");
        }}
      >
        <div>
          <h1 className="text-xl text-center mb-4">Verify login</h1>
          <p className="text-sm text-center text-grayscaleBody mb-6">
            A one-time code was sent to {otpMaskedEmail || "your email"}. Enter it below to continue.
          </p>
          {otpError && <div className="text-red-500 mb-4 text-sm">{otpError}</div>}
          <form onSubmit={onVerifyOtp}>
            <div className="input_container">
              <label className="input_title" htmlFor="loginOtp">
                <b>Verification code</b>
              </label>
              <input
                id="loginOtp"
                className="input_field"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={8}
                placeholder="Enter OTP"
                value={otpValue}
                disabled={isLoading}
                onChange={(ev) => {
                  setOtpValue(ev.target.value.replace(/\D/g, ""));
                  setOtpError("");
                }}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary btn-primary-full"
              disabled={isLoading || !otpValue}
            >
              {!isLoading ? "Verify & continue" : <LoadingSpinner color={"#305F32"} backgroundColor={""} />}
            </button>
          </form>
          <div className="text-center mt-4">
            <button
              type="button"
              className="btn btn-text"
              disabled={isLoading || resendingOtp}
              onClick={onResendOtp}
            >
              {resendingOtp ? "Sending…" : "Resend code"}
            </button>
          </div>
        </div>
      </Modal>

      <div className="login">
        <div className="login_head">
          <span>Don't have an account?</span>
          <Link to={RouteNames.REGISTER} className="ml-4 btn btn-outline">
            Register
          </Link>
        </div>
        <div className="login_form">
          <h1 className="login_form_head">Log In</h1>
          <button className="btn btn-outline google-btn">
            <img src={GoogleLogo} alt="" className="pr-4" />
            Log In Using Google
          </button>
          <Divider className="my-2" text="Or" />
          <div className="login_form_text">Log in using email address</div>
          <form className="pb-8">
            <div className="input_container">
              <label className="input_title" htmlFor="email">
                Email Address/Username
              </label>
              <input
                id="email"
                className="input_field"
                disabled={isLoading}
                type="text"
                placeholder={"Enter email address or Username"}
                {...register("userName")}
              />
              {errors.userName && (
                <ErrorViewer message={errors.userName.message as string} />
              )}
            </div>
            <div className="input_container">
              <label className="input_title" htmlFor="password">
                Password
              </label>
              <div className="input_password_cage">
                <input
                  id={"password"}
                  className="input_field"
                  disabled={isLoading}
                  type={!showPassword ? "password" : "text"}
                  placeholder={"Enter password"}
                  {...register("password")}
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FiEye /> : <FiEyeOff />}
                </span>
              </div>
              {errors.password && (
                <ErrorViewer message={errors.password.message as string} />
              )}
            </div>

            <button
              onClick={handleSubmit(onSubmit)}
              className="btn btn-primary btn-primary-full"
              disabled={isLoading}
            >
              {!isLoading ? (
                "Log In"
              ) : (
                <LoadingSpinner color={"#305F32"} backgroundColor={""} />
              )}
            </button>
          </form>
          <div className="text-center">
            <Link
              to={RouteNames.FORGOT_PASSWORD}
              className="btn btn-text btn-text-full"
            >
              Forgot Password?
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
